// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import vuexI18n from 'vuex-i18n'
import languages from './languages/vi'
import wysiwyg from 'vue-wysiwyg'
import VueQrcode from '@chenfengyuan/vue-qrcode'
// import vuemit from 'vuemit'
import firebase from 'firebase/app'

import './../static/css/bootstrap.min.css'
import './../static/font-awesome/css/all.min.css'
import './../static/css/main.css'
import './../static/css/tagify.css'
// import './../node_modules/croppie/croppie.css'
import './../node_modules/vue-wysiwyg/dist/vueWysiwyg.css'
Vue.config.productionTip = false
// window.Vuemit = vuemit
// https://github.com/dkfbasel/vuex-i18n
Vue.use(Vuex)

var firebaseConfig = {
  apiKey: 'AIzaSyDM1ibg3_4xV1eQNrPObJiwkn5xq9kPEEM',
  authDomain: 'cbs-lite-acbbe.firebaseapp.com',
  databaseURL: 'https://cbs-lite-acbbe.firebaseio.com',
  projectId: 'cbs-lite-acbbe',
  storageBucket: 'cbs-lite-acbbe.appspot.com',
  messagingSenderId: '142479695526',
  appId: '1:142479695526:web:6c9d9d099365e5d6fb5e67',
  measurementId: 'G-4E76V6GCF6'
}

firebase.initializeApp(firebaseConfig)

Vue.component(VueQrcode.name, VueQrcode)
window.GOOGLE_AUTOCOMPLETE = {
  'domain': 'https://maps.googleapis.com/maps/api/js',
  'key': 'AIzaSyAqXxSMOmWzN2_ghslCY_T-yXhxNWAnFwc',
  'library': 'places',
  // google inputs retrieved.
  'inputs': {
    administrative_area_level_1: 'long_name',
    street_number: 'short_name',
    postal_code: 'short_name',
    locality: 'long_name',
    country: 'long_name',
    route: 'long_name'
  }
}

window.Vuemit = require('vuemit')
const store = new Vuex.Store()
Vue.use(vuexI18n.plugin, store)
Vue.use(wysiwyg, {
  hideModules: {
    'separator': true,
    'image': true,
    'table': true,
    'code': true
  }
}) // config is optional. more below

Vue.i18n.add('vi', languages)
// set the start locale to use
Vue.i18n.set('vi')

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

window.vue = vm



// WEBPACK FOOTER //
// ./src/main.js